import Button from '@/components/Button';
import ModalHoc from '@/components/ModalHoc';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const EditRedirectModal = _ref => {
  let {
    onClose,
    onConfirm
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("button", {
      className: styles.close,
      onClick: () => onClose(false),
      children: /*#__PURE__*/_jsx("img", {
        src: "/icons/close.svg"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.message,
      children: [/*#__PURE__*/_jsx("div", {
        children: "To make changes to your data, please open your original data source."
      }), /*#__PURE__*/_jsx("div", {
        children: "Do you want to update the original document?"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.actions,
      children: [/*#__PURE__*/_jsx(Button, {
        variant: 'gray',
        onClick: () => onClose(false),
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        onClick: onConfirm,
        children: "Confirm"
      })]
    })]
  });
};

export default ModalHoc(EditRedirectModal, {
  modalClass: styles.modal,
  overlayclass: styles.overlay,
  hasCloseButton: false,
  indexable: true
});